// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal_overlay__1AcVe","content":"modal_content__33KSB","small":"modal_small__-v-iV","large":"modal_large__3oqoj"};